import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { FormlyBootstrapFormFieldModule } from '@ngx-formly/bootstrap/form-field';
import { FormlyBootstrapInputModule } from '@ngx-formly/bootstrap/input';
import { FormlyBootstrapTextAreaModule } from '@ngx-formly/bootstrap/textarea';
import { FormlyBootstrapRadioModule } from '@ngx-formly/bootstrap/radio';
import { FormlyBootstrapCheckboxModule } from '@ngx-formly/bootstrap/checkbox';
import { FormlyBootstrapMultiCheckboxModule } from '@ngx-formly/bootstrap/multicheckbox';
import { FormlyBootstrapSelectModule } from '@ngx-formly/bootstrap/select';
import { FormlyBootstrapAddonsModule } from '@ngx-formly/bootstrap/addons';

class FormlyBootstrapModule {
}
FormlyBootstrapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyBootstrapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormlyBootstrapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyBootstrapModule, imports: [FormlyBootstrapFormFieldModule,
        FormlyBootstrapInputModule,
        FormlyBootstrapTextAreaModule,
        FormlyBootstrapRadioModule,
        FormlyBootstrapCheckboxModule,
        FormlyBootstrapMultiCheckboxModule,
        FormlyBootstrapSelectModule,
        FormlyBootstrapAddonsModule] });
FormlyBootstrapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyBootstrapModule, imports: [[
            FormlyBootstrapFormFieldModule,
            FormlyBootstrapInputModule,
            FormlyBootstrapTextAreaModule,
            FormlyBootstrapRadioModule,
            FormlyBootstrapCheckboxModule,
            FormlyBootstrapMultiCheckboxModule,
            FormlyBootstrapSelectModule,
            FormlyBootstrapAddonsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: FormlyBootstrapModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormlyBootstrapFormFieldModule,
                        FormlyBootstrapInputModule,
                        FormlyBootstrapTextAreaModule,
                        FormlyBootstrapRadioModule,
                        FormlyBootstrapCheckboxModule,
                        FormlyBootstrapMultiCheckboxModule,
                        FormlyBootstrapSelectModule,
                        FormlyBootstrapAddonsModule,
                    ],
                }]
        }] });

/*
 * Public API Surface of bootstrap
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FormlyBootstrapModule };
